import { render, staticRenderFns } from "./DropdownSettings.vue?vue&type=template&id=7c3752f7&"
import script from "./DropdownSettings.vue?vue&type=script&lang=js&"
export * from "./DropdownSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports